export default __webpack_public_path__ + "static/media/icon-furnace.d079c639.svg";